import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <RankingSection />
        <AppSection />
        <CardsSection />
        <CarouselSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <MediaSection />
        <AboutSection />
        <UpdatesSection />
        <CommentsSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}